import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { User } from 'firebase/auth'

type UserState = (Pick<User, 'uid' | 'email'> & { roles?: string[] }) | null

interface AuthState {
  user: UserState
  loading: boolean
}

const initialState: AuthState = {
  user: null,
  loading: true,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<{ user: UserState }>) => {
      state.user = action.payload.user
      state.loading = false
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    clearAuth: state => {
      state.user = null
      state.loading = false
    },
  },
})

export const { setAuth, setLoading, clearAuth } = authSlice.actions
export default authSlice.reducer
